module.exports = __webpack_public_path__ + "static/media/Truth Is - ft Wvllvce.4d1486b0.jpg";